var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.16663C9.56667 9.16663 11.25 7.48329 11.25 5.41663C11.25 3.34996 9.56667 1.66663 7.5 1.66663C5.43333 1.66663 3.75 3.34996 3.75 5.41663C3.75 7.48329 5.43333 9.16663 7.5 9.16663ZM7.5 3.33329C8.65 3.33329 9.58333 4.26663 9.58333 5.41663C9.58333 6.56663 8.65 7.49996 7.5 7.49996C6.35 7.49996 5.41667 6.56663 5.41667 5.41663C5.41667 4.26663 6.35 3.33329 7.5 3.33329Z",
    fill: "#1E293B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 10H4.99984C3.15817 10 1.6665 11.4917 1.6665 13.3333V14.1667C1.6665 16.0083 3.15817 17.5 4.99984 17.5H9.99984C11.8415 17.5 13.3332 16.0083 13.3332 14.1667V13.3333C13.3332 11.4917 11.8415 10 9.99984 10ZM11.6665 14.1667C11.6665 15.0833 10.9165 15.8333 9.99984 15.8333H4.99984C4.08317 15.8333 3.33317 15.0833 3.33317 14.1667V13.3333C3.33317 12.4167 4.08317 11.6667 4.99984 11.6667H9.99984C10.9165 11.6667 11.6665 12.4167 11.6665 13.3333V14.1667Z",
    fill: "#1E293B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0916 10.8333H14.4666C14.0083 10.8333 13.6333 11.2083 13.6333 11.6666C13.6333 12.1249 14.0083 12.4999 14.4666 12.4999H16.0916C16.4083 12.4999 16.6666 12.7582 16.6666 13.0749V14.1666C16.6666 15.0833 15.9166 15.8333 15 15.8333H14.4666C14.0083 15.8333 13.6333 16.2083 13.6333 16.6666C13.6333 17.1249 14.0083 17.4999 14.4666 17.4999H15C16.8416 17.4999 18.3333 16.0083 18.3333 14.1666V13.0749C18.3333 11.8416 17.325 10.8333 16.0916 10.8333Z",
    fill: "#1E293B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10C16.375 10 17.5 8.875 17.5 7.5C17.5 6.125 16.375 5 15 5C13.625 5 12.5 6.125 12.5 7.5C12.5 8.875 13.625 10 15 10ZM15 6.66667C15.4583 6.66667 15.8333 7.04167 15.8333 7.5C15.8333 7.95833 15.4583 8.33333 15 8.33333C14.5417 8.33333 14.1667 7.95833 14.1667 7.5C14.1667 7.04167 14.5417 6.66667 15 6.66667Z",
    fill: "#1E293B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.4e8871083549074086e5be1fdf8e3fba.svg";
export { ForwardRef as ReactComponent };